// extracted by mini-css-extract-plugin
export default {"exceedTooltip":"src-components-ExceedTooltip-index-module__exceedTooltip--UhSG0"};